<template>
    <div class="progress-bar-wrapper">
        <span class="progress-bar" :style="{ width: adjustableProgress + '%', backgroundColor: color }"></span>
    </div>
</template>

<style lang="scss" scoped>
    // see /static/scss/components/_progressBar.scss
</style>

<script>
    import { gsap } from '@/vendor';

    export default {
        props: {
            value: {
                type: Number,
                default: 50
            },
            max: {
                type: Number,
                default: 100
            },
            color: {
                type: String,
                default: '#a5147e'
            }
        },

        data()
        {
            return {
                adjustableProgress: this.progress || 0
            };
        },

        computed: {
            progress()
            {
                return 100 / this.max * this.value;
            }
        },

        watch: {
            progress( val )
            {
                // console.log( val );
                if( this.anim )
                {
                    this.anim.kill();
                }
                this.anim = gsap.to( this, { adjustableProgress: val, duration: 1 });
            }
        },

        mounted()
        {
            this.anim = gsap.to( this, { adjustableProgress: this.progress, duration: 1 });
        },

        methods: {
        }
    };
</script>
